<template>
  <div class="section-box">
    <el-tabs v-model="seaType" type="card" class="customer-tabs-mg">
      <el-tab-pane v-for="(item, index) in titleCourse" :label="item.value" :name="item.key + ''" :key="index">
      </el-tab-pane>
    </el-tabs>
    <div class="customer-list">
      <div class="next-button" v-if="
          !(
            typeof actionData.customerghkh_add != 'undefined' &&
            !actionData.customerghkh_add
          )
        ">
        <el-button size="small" type="primary" @click="getCourseOrderList()">查询</el-button>
        <el-button size="small"  type="primary" icon="el-icon-download" @click="downloadFile()">下载数据</el-button>
        <el-button size="small" type="success" @click="resetSearch()">重置</el-button>
      </div>
    </div>

    <el-table :stripe="true" :data="tableData" style="width: 100%; margin-top: 20px" height="590" border
      v-loading="listLoading">
      <!-- eslint-disable  -->
      <el-table-column label="订单编号">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.orderNo" placeholder="输入关键字搜索" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.sorderNo || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="课程编号">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.courseNo" placeholder="输入关键字搜索" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.scourseNo || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="课程名称">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.courseName" placeholder="输入关键字搜索" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.scourseName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- <el-table-column label="课程类别">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-select size="mini" placeholder="请选择" v-model="form.courseType" style="width: 100%" filterable
              @change="getCourseOrderList()">
              <el-option value="" label="请选择"> </el-option>
              <el-option v-for="(item, index) in form.courseTypeArr" :value="item.key" :label="item.value" :key="index">
              </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.scourseType || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column> -->
      <el-table-column label="账号Code">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.accountCode" placeholder="输入关键字搜索" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.saccountCode || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="账号名称">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.accountName" placeholder="输入关键字搜索" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.saccountName || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="账户手机号">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.accountPhone" placeholder="输入关键字搜索" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.saccountPhone || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>

      <el-table-column label="支付金额">
        <el-table-column show-overflow-tooltip>
          <template slot="header" slot-scope="scope">
            <el-input size="mini" v-model="form.actualpriceEnd" placeholder="输入关键字搜索<=" @change="getCourseOrderList()" />
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.actualprice || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>


      <el-table-column label="购买时间">
        <el-table-column show-overflow-tooltip width="250">
          <template slot="header" slot-scope="scope">
            <el-date-picker size="mini" v-model="form.buyTimeArr" type="daterange" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" range-separator="—" start-placeholder="开始日期" end-placeholder="结束日期"
              style="width: 100%" @change="getCourseOrderList()"></el-date-picker>
          </template>
          <template slot-scope="scope">
            <span>{{ scope.row.dbuyTime || "--" }}</span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right" v-show="tableData.length">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="form.pageNum" :page-sizes="[10, 20, 50, 100, 200]" :page-size="form.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    courseOrderList,
    courseTyeList
  } from "@/service/courseListApi";
  import {
    getActionData
  } from "@/utils/store";
  export default {
    components: {},
    data() {
      return {
        seaType: '1',
        actionData: JSON.parse(getActionData()), //功能按钮每个页面必须用
        titleCourse: [],
        listLoading: false,
        form: {
          pageNum: 1,
          pageSize: 10,
          orderNo: "",
          courseNo: "",
          courseName: "",
          courseType: "",
          courseTypeArr: [],
          accountCode: "",
          accountName: "",
          accountPhone: "",
          buyTimeArr: [],

          actualpriceBegin: 0,  //支付金额开始
          actualpriceEnd: '',   //支付金额结束
        },
        searchData: {},
        oraginForm: {},
        total: 0,

        tableData: [],

        // 角标
        count0: 1,
        count1: 2,
        count2: 3,
        EffectivityTime: [],
      };
    },
    created() {
      this.oraginForm = JSON.parse(JSON.stringify(this.form));
      this.tableData = [];
      this.getTitle();
      this.getCourseOrderList();
      this.getCourseTypeList();
    },
    methods: {
      resetSearch(){
        this.form={
          pageNum: 1,
          pageSize: 10,
          orderNo: "",
          courseNo: "",
          courseName: "",
          courseType: "",
          courseTypeArr: [],
          accountCode: "",
          accountName: "",
          accountPhone: "",
          buyTimeArr: [],

          actualpriceBegin: 0,  //支付金额开始
          actualpriceEnd: '',   //支付金额结束
        }
        this.getCourseOrderList();
      },
      downloadFile() {
        var data = {};
        if (this.form.orderNo) data.sorderNo = this.form.orderNo;
        if (this.form.courseNo) data.scourseNo = this.form.courseNo;
        if (this.form.courseName) data.scourseName = this.form.courseName;
        if (this.form.courseType) data.ncourseTypeId = this.form.courseType;
        if (this.form.accountCode) data.saccountCode = this.form.accountCode;
        if (this.form.accountName) data.saccountName = this.form.accountName;
        if (this.form.accountPhone) data.saccountPhone = this.form.accountPhone;
        if(this.form.actualpriceEnd) {
          data.actualpriceBegin = this.form.actualpriceBegin;
          data.actualpriceEnd = this.form.actualpriceEnd;
        }
        if (
          this.form.buyTimeArr instanceof Array &&
          this.form.buyTimeArr.length > 0
        ) {
          data.dbuyTimeBegin = this.form.buyTimeArr[0] + " 00:00:00";
          data.dbuyTimeEnd = this.form.buyTimeArr[1] + " 23:59:59";
        } else {
          if (data.dbuyTimeBegin) delete data.dbuyTimeBegin;
          if (data.dbuyTimeEnd) delete data.dbuyTimeEnd;
        }

        let url =
          process.env.NODE_ENV == "development" ?
          "/api2" :
          process.env.VUE_APP_API2;

        window.open(
          url + "/gz/admin/courseOrder/download" + "?" + this.parseJsonURL(data)
        );
      },
      parseJsonURL(json) {
        if (!json) return "";
        if (typeof json == "string") return json;
        return this.cleanArray(
          Object.keys(json).map(function (key) {
            if (json[key] === undefined) return "";
            return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
          })
        ).join("&");
      },
      cleanArray(actual) {
        var newArray = [];
        for (var i = 0; i < actual.length; i++) {
          if (actual[i]) {
            newArray.push(actual[i]);
          }
        }
        return newArray;
      },
      getCourseTypeList() {
        courseTyeList().then((r) => {
          if (r.Result == 1) {
            this.form.courseTypeArr = r.Data || [];
          }
        });
      },
      async getCourseOrderList() {
        this.listLoading = true;
        var data = {
          pageNum: 1,
          pageSize: 10,
          rational: false,
        };
        if (
          this.form.buyTimeArr instanceof Array &&
          this.form.buyTimeArr.length > 0
        ) {
          data.dbuyTimeBegin = this.form.buyTimeArr[0] + " 00:00:00";
          data.dbuyTimeEnd = this.form.buyTimeArr[1] + " 23:59:59";
        } else {
          if (data.dbuyTimeBegin) delete data.dbuyTimeBegin;
          if (data.dbuyTimeEnd) delete data.dbuyTimeEnd;
        }
        if (this.form.courseType) data.ncourseTypeId = this.form.courseType;
        if (this.form.accountCode) data.saccountCode = this.form.accountCode;
        if (this.form.accountName) data.saccountName = this.form.accountName;
        if (this.form.accountPhone) data.saccountPhone = this.form.accountPhone;
        if (this.form.courseName) data.scourseName = this.form.courseName;
        if (this.form.courseNo) data.scourseNo = this.form.courseNo;
        if (this.form.orderNo) data.sorderNo = this.form.orderNo;
        if(this.form.actualpriceEnd) {
          data.actualpriceBegin = this.form.actualpriceBegin;
          data.actualpriceEnd = this.form.actualpriceEnd;
        }
      data.pageNum=this.form.pageNum;
      data.pageSize=this.form.pageSize;

        let res = await courseOrderList(data);
        this.listLoading = false;
        if (res.Result != 1) {
          return this.$message.error("获取失败请联系开发人员");
        }
        this.tableData = res.Data.datas;
        this.total = res.Data.total;
      },
      getTitle() {
        this.titleCourse = [{
          key: 1,
          value: "课程订单",
        }, ];
      },
      handleSizeChange(val) {
        if (this.listLoading) return;
        this.form.pageNum = 1;
        this.form.pageSize = val;
        this.getCourseOrderList();
      },
      handleCurrentChange(val) {
    
        if (this.listLoading) return;
        this.form.pageNum = val;
       
        this.getCourseOrderList();
      },
    },
  };
</script>
<style lang="scss">
  .customer-tabs-mg {
    .el-tabs__header {
      margin: 0 0 15px !important;
    }
  }

  .customer-list {
    position: relative;

    .next-button {
      position: absolute;
      right: 0;
      top: -56px;
    }
  }

  .customer-row-bg {
    padding: 20px 14px;
    background-color: #f9fafc;
    display: flex;
    align-items: center;

    .el-form-item {
      margin-bottom: 0 !important;
    }

    .selected {
      color: #409eff;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }

  .linkInfo {
    cursor: pointer;

    &:hover {
      color: #409eff;
    }
  }
</style>